import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexInputs',
  setup(__props) {

const SimpleInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/SimpleInput.vue"))
const SizingInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/SizingInput.vue"))
const BasicInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/BasicInput.vue"))
const FlatStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/FlatStyle.vue"))
const EdgesStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/EdgesStyle.vue"))
const RaiseStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/RaiseStyle.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      mains: "Base Inputs",
      title: "Base Inputs"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(SimpleInput)),
        _createVNode(_unref(SizingInput)),
        _createVNode(_unref(BasicInput)),
        _createVNode(_unref(FlatStyle)),
        _createVNode(_unref(EdgesStyle)),
        _createVNode(_unref(RaiseStyle))
      ])
    ])
  ], 64))
}
}

})